import { Navigate } from 'react-router-dom';
import { ROUTES } from '../../../routes/routes';

/**
 * The Returns desk is retired [SSD-7527]. A returned parcel is restocked from View Orders' return mode (reached from
 * Order Detail's "Restock a return in View Orders", from Arrival Sort, or by the waybill in the address) or line by
 * line from Order Detail's Return putaway, both with the phone camera for the shelf. The old address lands on View
 * Orders so a bookmark still goes somewhere.
 */
export default function FulfillmentReturnsPage() {
  return <Navigate to={ROUTES.fulfillment.viewOrders} replace />;
}
